export const companySliceName = "company"; 

export const companyInitState = {
  uuid: null,
  name: null,
  phone: null,
  hotline: null,
  address: null,
  email: null,
  password: null,
  website: null,
  subsidiaries: [],
  subsidiarySelected: {},
  timeframes: [],
  grades: [],
  subjects: [],
  teachers: [],
  courses: [],
  weekdays: [], 
  appUsers: [],
  emailTemplates: [],
};
